/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { MapApi } from "client";
import { useState } from "react";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { Const } from "const";

export const useGetJobsiteMap = () => {
  const [getMapListApi, cancelGetMapListApi] = useApiWithTimeout(
    MapApi,
    Const.operationTimeout.getProjectList
  );
  const [targetJobsiteId, setTargetJobsiteId] = useState<string>();
  const result = useCallApi(
    async () => {
      let maps = undefined;
      if (targetJobsiteId) {
        const mapInfos = await getMapListApi.getJobsiteMaps({
          jobSiteId: targetJobsiteId ?? "",
        });
        maps = mapInfos.maps;
      }
      return maps;
    },
    cancelGetMapListApi,
    [cancelGetMapListApi, getMapListApi, targetJobsiteId]
  );
  return { ...result, setTargetJobsiteId };
};
